import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconUnlink } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import useDeleteEntityLink from 'src/Components/EntityLinks/hooks/useDeleteEntityLink';
import { RowActions } from 'src/Components/Shared/RowActions';
import { LinkOrigin } from 'src/Services/API/EntityLinks.api';
import { trackEntityLinkDeleted } from 'src/Services/Mixpanel/events';

import { Props } from './LinkedEntityActionMenu.types';

// BUSINESS links (derived from Expense.paidByContact, *Attachment, ...) aren't stored
// as their own row — nothing to delete, and item.linkId is never set for them.
const LinkedEntityActionMenu = ({ item, sourceType, sourceId }: Props) => {
  const { t } = useTranslation();
  const { mutate: deleteLink } = useDeleteEntityLink();

  if (item.linkOrigin === LinkOrigin.Business || !item.linkId) return null;
  const linkId = item.linkId;

  const handleUnlink = () => {
    modals.openConfirmModal({
      title: t('entityLinks.confirmUnlinkTitle', 'Délier cet élément ?'),
      children: t(
        'entityLinks.confirmUnlinkMessage',
        "L'élément « {{title}} » ne sera plus lié à cette fiche.",
        { title: item.title }
      ),
      labels: { confirm: t('entityLinks.unlink', 'Délier'), cancel: t('common.cancel', 'Annuler') },
      confirmProps: { color: 'red' },
      onConfirm: () => {
        deleteLink(
          { linkId, sourceType, sourceId, otherType: item.entityType, otherId: item.entityId },
          {
            onSuccess: () => {
              trackEntityLinkDeleted({
                source_entity_type: sourceType,
                target_entity_type: item.entityType,
              });
              notifications.show({
                message: t('entityLinks.unlinkSuccess', 'Élément délié.'),
                color: 'teal',
              });
            },
            onError: () => {
              notifications.show({
                message: t('entityLinks.unlinkError', 'Impossible de délier cet élément.'),
                color: 'red',
              });
            },
          }
        );
      },
    });
  };

  return (
    <RowActions
      actions={[
        {
          key: 'unlink',
          label: t('entityLinks.unlink', 'Délier'),
          icon: <IconUnlink size={18} />,
          variant: 'danger',
          onClick: handleUnlink,
        },
      ]}
    />
  );
};

export default LinkedEntityActionMenu;
